/**
 * The icon color of each point button: brand green to add, brand orange to
 * take out. Kept apart from the component so its contrast test loads no UI.
 */
export const POINT_BUTTON_TONE = {
  add: 'text-primary-600',
  remove: 'text-tertiary-700',
} as const;
